import { render, staticRenderFns } from "./TrackingCategoriesDonePopup.vue?vue&type=template&id=47e721b2&scoped=true"
import script from "./TrackingCategoriesDonePopup.vue?vue&type=script&lang=js"
export * from "./TrackingCategoriesDonePopup.vue?vue&type=script&lang=js"
import style0 from "./TrackingCategoriesDonePopup.vue?vue&type=style&index=0&id=47e721b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e721b2",
  null
  
)

export default component.exports